module.exports = ['$scope', '$http', function($scope, $http) {
    $scope.testclick = function() {
        alert('worked uh huh2');
    }
    $scope.amedaClick = function() {
        // pds 10:50 AM
        this.closeModal();
       // window.open("http://insured.amedadirect.com/");
    }
    $scope.redirectHome = function(){
        location.replace("/member/home/");
    }
}];

